import { Injectable } from '@angular/core';
import {DataService} from "./data.service";
import {ActivatedRouteSnapshot, RouterStateSnapshot} from "@angular/router";
import {Observable} from "rxjs";
import {HomeContent} from "../interfaces/home-content";

@Injectable({
  providedIn: 'root'
})
export class HomeResolverService {

  constructor(
    private data: DataService
  ) { }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<HomeContent> {
    return this.data.getHomeContent()
  }
}
